import { createContext, useContext, useEffect } from "react";

const defaultConfig = { flushBottom: false };

export const PageLayoutContext = createContext(null);

export const usePageLayout = ({ flushBottom = false } = {}) => {
  const setPageLayout = useContext(PageLayoutContext);

  useEffect(() => {
    if (!setPageLayout) return undefined;

    setPageLayout({ flushBottom });
    return () => setPageLayout(defaultConfig);
  }, [flushBottom, setPageLayout]);
};
